import { useMutation } from 'react-query';
import { deleteDrug } from 'src/services/api/drugs';

function useDeleteDrug() {
  return useMutation((drug) => deleteDrug(drug));
}

export default useDeleteDrug;
